export enum IOrientation {
  VERTICAL = 'Vertical',
  HORIZONTAL = 'Horizontal',
}
export enum INoScreens {
  ONE = '1',
  TWO = '2',
  THREE = '3',
  FOUR = '4',
  FIVE = '5',
  SIX = '6',
  SEVEn = '7',
}
export interface SelectLayoutFormProps {
  layoutTypeId: number;
  setActive: (active: string) => void;
}
export interface RadioSearchParam {
  num_screens: number;
  orientation: string;
}
